/** "3h ago" / "19 Oct" — how recent a news photo is (from its report's publish time). */
export const photoAge = (when) => {
  const ms = Date.now() - new Date(when).getTime();
  if (!Number.isFinite(ms) || ms < 0) return '';
  const hours = Math.floor(ms / 3600000);
  if (hours < 1) return `${Math.max(1, Math.floor(ms / 60000))}m ago`;
  if (hours < 48) return `${hours}h ago`;
  return new Date(when).toLocaleDateString([], { day: 'numeric', month: 'short' });
};
